'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var _ = require('./');

var TabsStyles = _reactStyle2['default'].create({
  normalStyle: {
    position: 'relative',
    width: '100%'
  },

  tabTitlesContainerStyle: {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    backgroundColor: _style.Colors.cyan.P500,
    lineHeight: '48px',
    margin: 0,
    padding: 0,
    height: 48,
    position: 'relative',
    cursor: 'pointer',
    color: 'white',
    fontSize: 14,
    fontWeight: '500',
    boxShadow: '0px 3px 2px rgba(0, 0, 0, 0.2)'
  },

  tabTitleStyle: {
    height: '100%',
    display: 'inline-block',
    textAlign: 'center',
    userSelect: 'none',
    position: 'relative',
    overflow: 'hidden',
    opacity: '.6',
    transition: 'opacity .38s linear'
  },

  tabTitleSelectedStyle: {
    opacity: '1'
  },

  selectionBarStyle: {
    backgroundColor: _style.Colors.yellow.A100,
    height: 2,
    transition: 'left .28s linear',
    position: 'absolute',
    bottom: 0
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'getSelectedChild',
    value: function getSelectedChild(children) {
      var defaultVal = {
        selectedTab: null,
        selectedIndex: 0
      };
      if (!children) {
        return defaultVal;
      }
      if (!Array.isArray(children)) {
        children = [children];
      }
      return children.reduce(function (accu, child, index) {
        if (!child.props.selected) {
          return accu;
        }
        accu.selectedTab = child;
        accu.selectedIndex = index;
        return accu;
      }, defaultVal);
    }
  }, {
    key: 'onTabHeaderClick',
    value: function onTabHeaderClick(e) {
      var onChange = this.props.onChange;

      if (onChange) {
        var position = 0;
        var target = e.target;

        while (target.previousSibling) {
          target = target.previousSibling;
          position++;
        }

        // enhance the event with the position of the blind
        e.position = position;
        onChange(e);
      }
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs(children, tabTitleStyle, tabTitleSelectedStyle) {
      var _this = this;

      if (!children) {
        return null;
      }
      if (!Array.isArray(children)) {
        children = [children];
      }

      return children.map(function (child, index) {
        var childProps = child.props;
        var tabTitleStyles = [tabTitleStyle];

        if (childProps.selected) {
          tabTitleStyles.push(tabTitleSelectedStyle);
        }

        tabTitleStyles.push({ width: 100 / children.length + '%' });
        return _react2['default'].createElement(
          'li',
          {
            key: index,
            styles: tabTitleStyles },
          _react2['default'].createElement(_.RippleContainer, { onClick: _this.onTabHeaderClick.bind(_this) }),
          childProps.title
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var styles = _props.styles;
      var normalStyle = TabsStyles.normalStyle;
      var selectionBarStyle = TabsStyles.selectionBarStyle;
      var tabTitlesContainerStyle = TabsStyles.tabTitlesContainerStyle;
      var tabTitleSelectedStyle = TabsStyles.tabTitleSelectedStyle;
      var tabTitleStyle = TabsStyles.tabTitleStyle;

      var normalStyles = [normalStyle];
      if (styles) {
        normalStyles = normalStyles.concat(styles);
      }

      var _getSelectedChild = this.getSelectedChild(children);

      var selectedIndex = _getSelectedChild.selectedIndex;
      var selectedTab = _getSelectedChild.selectedTab;

      var selectionBarStyles = [selectionBarStyle, {
        width: 100 / children.length + '%',
        left: 100 / children.length * selectedIndex + '%'
      }];
      return _react2['default'].createElement(
        'div',
        { styles: normalStyles },
        _react2['default'].createElement(
          'ul',
          { styles: tabTitlesContainerStyle },
          this.renderTabs(children, tabTitleStyle, tabTitleSelectedStyle),
          _react2['default'].createElement('div', { styles: selectionBarStyles })
        ),
        selectedTab
      );
    }
  }], [{
    key: 'displayName',
    value: 'Tabs',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _react.PropTypes.node,
      onChange: _react.PropTypes.func,
      styles: _react.PropTypes.object
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/Tabs.js
 ** module id = 217
 ** module chunks = 0
 **/